import DocUpdateIcon from "../../assets/DocUpdateIcon.svg";
import Forbes2xImg from "../../assets/Forbes2x.png";
import Badge500Img from "../../assets/500.webp";
import SOC2LogoImg from "../../assets/SOC2-Logo.png";
import GPTWBadgeImg from "../../assets/Impiricus_US_English_2025_Certification_Badge_large.png";
import FortuneAccoladeImg from "../../assets/Fortune-Accolade-GPTW-Health-Care.png";
import VantaHipaaBadge from "../VantaHipaaBadge/VantaHipaaBadge";
import "./WPFooter.css";

const WPFooter = () => {
  return (
    <footer className="wp-footer">
      <div className="wp-footer__container">
        {/* ===== Top section ===== */}
        <div className="wp-footer__top">
          {/* Left column: logo + nav + social */}
          <div className="wp-footer__top-left">
            <a
              href="https://www.docupdate.io/"
              className="wp-footer__logo"
              aria-label="DocUpdate Home"
            >
              <img
                src={DocUpdateIcon}
                alt="DocUpdate"
                className="wp-footer__logo-img"
              />
            </a>

            <nav className="wp-footer__nav" aria-label="Footer">
              <a
                href="https://www.docupdate.io/manage-preferences/"
                className="wp-footer__nav-link"
              >
                Manage Preferences
              </a>
              <a
                href="https://www.docupdate.io/#faq"
                className="wp-footer__nav-link"
              >
                Help
              </a>
              <a
                href="https://www.docupdate.io/privacy-policy/"
                className="wp-footer__nav-link"
              >
                Privacy Policy
              </a>
            </nav>

            {/* Social icons — 28px SVGs from the new docupdate.io footer */}
            <div className="wp-footer__social">
              <a
                href="https://www.facebook.com/GetDocUpdate"
                target="_blank"
                rel="noopener noreferrer"
                className="wp-footer__social-link"
                aria-label="Facebook"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <g clipPath="url(#wp-footer-fb)">
                    <path
                      d="M16 0C7.164 0 0 7.164 0 16c0 7.503 5.166 13.8 12.135 15.529V20.89H8.836V16h3.299v-2.107c0-5.446 2.465-7.97 7.811-7.97 1.014 0 2.763.2 3.479.398v4.432a12.3 12.3 0 0 0-1.849-.02c-2.623 0-3.637.994-3.637 3.578V16h5.226l-.897 4.89h-4.329v10.993C25.862 30.926 32 24.18 32 16 32 7.164 24.836 0 16 0Z"
                      fill="#101935"
                    />
                  </g>
                  <defs>
                    <clipPath id="wp-footer-fb">
                      <rect width="32" height="32" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
              <a
                href="https://www.instagram.com/getdocupdate/"
                target="_blank"
                rel="noopener noreferrer"
                className="wp-footer__social-link"
                aria-label="Instagram"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <g clipPath="url(#wp-footer-ig)">
                    <path
                      d="M16 2.881c4.275 0 4.781.019 6.463.094 1.562.069 2.406.331 2.969.55.743.287 1.281.637 1.837 1.194.563.562.906 1.094 1.194 1.837.218.563.481 1.412.55 2.969.075 1.687.094 2.194.094 6.469s-.019 4.781-.094 6.462c-.069 1.563-.331 2.407-.55 2.97a4.913 4.913 0 0 1-1.194 1.837 4.913 4.913 0 0 1-1.837 1.194c-.563.218-1.413.481-2.97.55-1.687.075-2.193.094-6.462.094s-4.781-.019-6.463-.094c-1.562-.069-2.406-.331-2.968-.55a4.913 4.913 0 0 1-1.838-1.194 4.913 4.913 0 0 1-1.193-1.837c-.22-.563-.482-1.413-.55-2.97-.075-1.687-.094-2.193-.094-6.468s.019-4.782.094-6.463c.068-1.562.33-2.406.55-2.969a4.913 4.913 0 0 1 1.193-1.837A4.913 4.913 0 0 1 6.57 3.525c.562-.219 1.412-.481 2.968-.55C11.22 2.9 11.725 2.881 16 2.881ZM16 0C11.656 0 11.113.019 9.406.094 7.706.169 6.538.444 5.525.838A7.87 7.87 0 0 0 2.688 2.687 7.87 7.87 0 0 0 .838 5.519C.444 6.537.169 7.7.094 9.4.019 11.112 0 11.656 0 16s.019 4.888.094 6.594c.075 1.7.35 2.869.744 3.881a7.87 7.87 0 0 0 1.85 2.838A7.87 7.87 0 0 0 5.519 31.156c1.019.394 2.181.669 3.881.744C11.106 31.975 11.65 31.994 15.994 31.994s4.881-.019 6.594-.094c1.7-.075 2.869-.35 3.881-.744a7.87 7.87 0 0 0 2.838-1.844 7.87 7.87 0 0 0 1.843-2.837c.394-1.019.669-2.181.744-3.881.075-1.706.094-2.25.094-6.594s-.019-4.881-.094-6.588c-.075-1.7-.35-2.868-.744-3.881a7.87 7.87 0 0 0-1.85-2.844A7.87 7.87 0 0 0 26.481.843C25.463.45 24.3.175 22.6.1 20.888.019 20.344 0 16 0Z"
                      fill="#101935"
                    />
                    <path
                      d="M16 7.781A8.219 8.219 0 1 0 16 24.22 8.219 8.219 0 0 0 16 7.78Zm0 13.55a5.331 5.331 0 1 1 0-10.662 5.331 5.331 0 0 1 0 10.663Z"
                      fill="#101935"
                    />
                    <path
                      d="M26.463 7.456a1.919 1.919 0 1 1-3.838 0 1.919 1.919 0 0 1 3.838 0Z"
                      fill="#101935"
                    />
                  </g>
                  <defs>
                    <clipPath id="wp-footer-ig">
                      <rect width="32" height="32" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/docupdate"
                target="_blank"
                rel="noopener noreferrer"
                className="wp-footer__social-link"
                aria-label="LinkedIn"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <g clipPath="url(#wp-footer-li)">
                    <path
                      d="M29.631 0H2.363C1.056 0 0 1.031 0 2.306v27.381C0 30.963 1.056 32 2.363 32h27.268C30.938 32 32 30.963 32 29.694V2.306C32 1.031 30.938 0 29.631 0ZM9.494 27.269H4.744V11.994h4.75v15.275ZM7.119 9.913a2.756 2.756 0 1 1 0-5.5 2.756 2.756 0 0 1 0 5.5Zm20.15 17.356h-4.744V19.844c0-1.769-.031-4.05-2.469-4.05-2.469 0-2.844 1.931-2.844 3.925v7.55h-4.737V11.994h4.55v2.087h.063a4.985 4.985 0 0 1 4.487-2.469c4.806 0 5.694 3.163 5.694 7.275v8.381Z"
                      fill="#101935"
                    />
                  </g>
                  <defs>
                    <clipPath id="wp-footer-li">
                      <rect width="32" height="32" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div>
          </div>

          {/* Right column: certification badges */}
          <div className="wp-footer__badges">
            <div>
              <img
                src={Forbes2xImg}
                alt="Forbes"
                className="wp-footer__badge"
                loading="lazy"
              />
            </div>
            <a
              href="https://www.greatplacetowork.com/certified-company/7087458"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={Badge500Img}
                alt="Deloitte Technology Fast 500"
                className="wp-footer__badge"
                loading="lazy"
              />
            </a>
            <a
              href="https://app.vanta.com/impiricus.com/trust/7j9de7fa6wru6k8fejvxj/controls"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={SOC2LogoImg}
                alt="SOC 2"
                className="wp-footer__badge"
                loading="lazy"
              />
            </a>
            <a
              href="https://www.greatplacetowork.com/certified-company/7087458"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={GPTWBadgeImg}
                alt="Great Place to Work Certified"
                className="wp-footer__badge"
                loading="lazy"
              />
            </a>
            <a
              href="https://www.greatplacetowork.com/certified-company/7087458"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={FortuneAccoladeImg}
                alt="Fortune Best Workplaces in Health Care"
                className="wp-footer__badge"
                loading="lazy"
              />
            </a>
            <VantaHipaaBadge className="wp-footer__badge" />
          </div>
        </div>

        {/* ===== Divider + bottom row ===== */}
        <div className="wp-footer__bottom-wrap">
          <div className="wp-footer__bottom">
            <p className="wp-footer__copyright">
              Copyright © {new Date().getFullYear()}&nbsp; DocUpdate | All
              Rights Reserved.
            </p>

            <nav className="wp-footer__legal" aria-label="Legal">
              <a
                href="https://www.docupdate.io/terms-of-service/"
                className="wp-footer__legal-link"
              >
                Terms of Service
              </a>
              <a
                href="https://www.docupdate.io/do-not-call-policy/"
                className="wp-footer__legal-link"
              >
                DNC Policy
              </a>
              <a
                href="https://www.docupdate.io/hipaa-business-associate-agreement/"
                className="wp-footer__legal-link"
              >
                HIPAA Terms
              </a>
              <a
                href="https://www.docupdate.io/ccpa-notice/"
                className="wp-footer__legal-link"
              >
                CCPA Notice
              </a>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default WPFooter;